import React, { useCallback } from 'react';
import { ActionButton } from '../../action/react/action-button';
import { useUserClient } from '../../react-hooks/useUserClient';

const logo = `         <svg style="width:15rem;margin:8rem auto" version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 1144.4 360" style="enable-background:new 0 0 1144.4 360;" xml:space="preserve">
<style type="text/css">
	.st0 {
        clip-path: url(#SVGID_2_);
    }

    .st1 {
        fill: #DE3321;
    }

    .st2 {
        clip-path: url(#SVGID_4_);
    }

    .st3 {
        fill: #003D5C;
    }

    .st4 {
        clip-path: url(#SVGID_6_);
    }

    .st5 {
        clip-path: url(#SVGID_8_);
    }
</style>
             <g id="Ebene_1">
	<g>
		<defs>
			<polyline id="SVGID_1_" points="0,448.5 0,0 1142.4,0 1142.4,448.5 			"/>
		</defs>
        <clipPath id="SVGID_2_">
			<use xlink:href="#SVGID_1_" style="overflow:visible;"/>
		</clipPath>
        <g class="st0">
			<path class="st1" d="M174.4,180.3c-14-24.3-5.7-55.3,18.6-69.3c24.3-14,55.3-5.7,69.3,18.6l87.9-50.8
				C307.9,6.1,214.7-18.4,142,23.9C69.8,66,45,158.5,86.5,231.1L174.4,180.3L174.4,180.3z"/>
            <path class="st1" d="M86.7,230.9c14,24.3,45.1,32.6,69.3,18.6c24.3-14,32.6-45.1,18.6-69.3l87.9-50.8
				c41.6,73.1,16.1,166.1-56.9,207.7c-72.5,41.3-164.7,16.6-206.8-55.4L86.7,230.9L86.7,230.9z"/>
		</g>
	</g>
                 <g>
		<defs>
			<polyline id="SVGID_3_" points="0,448.5 0,0 1142.4,0 1142.4,448.5 			"/>
		</defs>
                     <clipPath id="SVGID_4_">
			<use xlink:href="#SVGID_3_" style="overflow:visible;"/>
		</clipPath>
                     <g class="st2">
			<path class="st3" d="M508.4,357.8c-28.9,0-54-4.5-75.1-13.4s-40.5-22.8-58-41.7l55.6-55.6c10.9,11.7,23.8,21.5,38,28.8
				c14.4,7,30.3,10.5,46.3,10.2c14.6,0,25.9-2.5,33.9-7.6s11.9-12,11.9-20.7c0.3-7.8-3.1-15.4-9-20.5c-6.9-5.8-14.8-10.4-23.2-13.7
				c-9.4-3.9-20-7.8-31.7-11.7c-11.8-3.9-23.3-8.5-34.6-13.6c-11.3-5.2-21.9-11.8-31.5-19.7c-9.7-8.1-17.5-18-23.2-29.2
				c-5.9-11.5-8.8-26.1-8.8-43.6c0-21.8,5.3-40.6,15.9-56.5c10.8-16.2,26.2-28.8,44.1-36.3C478,4.6,499.9,0.5,525,0.5
				c23.8-0.2,47.3,4.1,69.5,12.7c21.3,8.4,38.6,20.2,51.9,35.1l-55.6,55.6c-9-9.7-19.7-17.8-31.5-23.9c-11-5.3-23.1-8-35.3-7.8
				c-12,0-21.5,2.1-28.3,6.3c-6.5,3.7-10.4,10.6-10.2,18c-0.2,7.3,3,14.3,8.8,18.8c7,5.4,14.9,9.8,23.2,12.9
				c9.6,3.9,20.2,7.8,31.7,11.7c11.7,4,23.2,8.5,34.4,13.7c11.3,5.2,21.9,11.9,31.4,20c9.8,8.4,17.7,18.9,23.2,30.7
				c5.8,12.4,8.8,27.3,8.8,44.9c0,34.1-12.2,60.8-36.6,80C585.9,348.3,552,357.9,508.4,357.8"/>
		</g>
	</g>
                 <rect x="666.8" y="6.3" class="st3" width="87.3" height="345.6"/>
                 <g>
		<defs>
			<polyline id="SVGID_5_" points="0,448.5 0,0 1175.3,0 1175.3,448.5 			"/>
		</defs>
                     <clipPath id="SVGID_6_">
			<use xlink:href="#SVGID_5_" style="overflow:visible;"/>
		</clipPath>
                     <g class="st4">
			<path class="st3" d="M958.4,280.3c19.2,0,36-4.2,50.5-12.7c14.3-8.3,25.9-20.7,33.2-35.6c7.6-15.3,11.4-33.2,11.4-53.6
				c0.2-13.9-2.1-27.8-6.6-40.9c-4.1-11.9-10.7-22.8-19.3-31.9c-8.5-8.9-18.8-15.9-30.2-20.5c-12.4-4.8-25.7-7.2-39-7.1
				c-19.2,0-35.9,4.1-50.2,12.4c-14.3,8.2-25.9,20.4-33.4,35.1c-8,15.1-12,32.7-12,52.9c-0.2,14.3,2,28.6,6.6,42.2
				c4.1,12,10.6,22.9,19.3,32.2c8.5,9,18.9,16,30.5,20.5C931.6,278.1,944.9,280.5,958.4,280.3 M959.3,358.3
				c-25.2,0.3-50.2-4.4-73.6-13.7c-21.9-8.7-41.8-21.6-58.8-38c-16.8-16.3-30.1-35.8-39.2-57.3c-9.5-22.4-14.3-46.6-14.1-70.9
				c-0.5-47.9,18.5-93.9,52.7-127.5c16.7-16.5,36.6-29.4,58.5-37.8c47.5-17.5,99.7-17.5,147.2,0c21.9,8.4,41.8,21.3,58.5,37.8
				c34.2,33.8,53.2,79.9,52.7,128c0.5,48-18.5,94.2-52.7,128c-16.7,16.5-36.5,29.4-58.3,38C1009,354,984.3,358.6,959.3,358.3"/>
		</g>
	</g>
</g>
             <g id="Ebene_2">
	<g>
		<defs>
			<polyline id="SVGID_7_" points="1169.4,448.5 1169.4,0 2311.8,0 2311.8,448.5 			"/>
		</defs>
        <clipPath id="SVGID_8_">
			<use xlink:href="#SVGID_7_" style="overflow:visible;"/>
		</clipPath>
        <g class="st5">
			<path class="st1" d="M1343.8,180.3c-14-24.3-5.7-55.3,18.6-69.3c24.3-14,55.3-5.7,69.3,18.6l87.9-50.8
				c-42.3-72.7-135.6-97.2-208.2-54.9c-72.2,42.1-97,134.6-55.5,207.1L1343.8,180.3L1343.8,180.3z"/>
            <path class="st1" d="M1256.1,230.9c14,24.3,45.1,32.6,69.3,18.6c24.3-14,32.6-45.1,18.6-69.3l87.9-50.8
				c41.6,73.1,16.1,166.1-56.9,207.7c-72.5,41.3-164.7,16.6-206.8-55.4L1256.1,230.9L1256.1,230.9z"/>
		</g>
	</g>
</g>
</svg>`

export const addDashboardConifg = {
    type: 'view',
    viewId: 'dashboard/dashboard-editor-view',
    preset: 'new',
    reload: false,
    bulk: false,
    bulkOnly: false,
    hidden: false,
    permissions: {
        authentication: true,
        permissions: ['ROLE_USER'],
        conditions: [],
    },
    includeArchived: false,
    modal: true,
    label: 'Dashboard erstellen',
    buttonClass: 'btn-primary',
};

const Welcome = () => {
    const [userClient, hasRole] = useUserClient();
    const hasDashboardRole = useCallback(() => {
        const data = hasRole('manage-dashboard');
        return data;
    }, []);

    return (
        <div className="text-center">
            <div dangerouslySetInnerHTML={{__html: logo}}/>
            <h1 className="tw-text-4xl">Herzlich willkommen bei SIO!</h1>
            {hasDashboardRole() && (
                <div style={{ marginTop: '30px' }}>
                    <ActionButton
                        config={addDashboardConifg}
                        context={{}}
                        onSubmitted={() => window.location.reload()}
                    />
                </div>
            )}
        </div>
    );
};

export default Welcome;
